/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search by name..." |
*
* @param {Tournaments_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_search_placeholder = /** @type {((inputs?: Tournaments_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome...")
	return /** @type {LocalizedString} */ ("Search by name...")
});